/**
 * Cloudflare R2 Asset Configuration
 * This file centralizes R2 asset management for the TestingVala platform.
 */

const R2_PUBLIC_URL = import.meta.env.VITE_R2_PUBLIC_URL || 'https://assets.testingvala.com';

export const R2_ASSETS = {
  // Base paths
  BASE_URL: R2_PUBLIC_URL,
  WEBINARS: `${R2_PUBLIC_URL}/webinars`,
  FALLBACKS: `${R2_PUBLIC_URL}/fallbacks`,

  // Branded fallback images
  BRANDED_FALLBACK: '/assets/webinar-fallback.png',
  PLACEHOLDER_BANNER: `${R2_PUBLIC_URL}/webinars/default-banner.webp`,
  
  // Featured assets
  FEATURED_BADGE: `${R2_PUBLIC_URL}/assets/featured-badge.webp`,
};

/**
 * Helper to get an R2 asset URL or return the original if it's already an absolute URL
 */
export const getR2Url = (path) => {
  if (!path) return R2_ASSETS.BRANDED_FALLBACK;
  if (path.startsWith('http') || path.startsWith('/')) return path;
  return `${R2_PUBLIC_URL}/${path.replace(/^\//, '')}`;
};
